import React from "react";
import { Table, Badge } from "react-bootstrap";

const SOURCE_VARIANT = { SYSTEM: "light", REVIEWER: "info", APPROVER: "primary", RECALCULATION: "warning" };

// Phase 3C, §27/§30. `fields`: GET /api/form-submissions/:id/result/fields —
// one row per field (or per repeating-row field, distinguished by row_number).
export default function FormFieldScoreBreakdown({ fields }) {
  if (!fields || !fields.length) {
    return <div className="text-muted small">No field-level scoring configured for this form.</div>;
  }

  return (
    <Table size="sm" responsive className="mb-0">
      <thead>
        <tr>
          <th>Field</th>
          <th>Row</th>
          <th>Score</th>
          <th>Maximum</th>
          <th>Status</th>
          <th>Source</th>
          <th>Remarks</th>
        </tr>
      </thead>
      <tbody>
        {fields.map((f) => (
          <tr key={f.id}>
            <td>{f.label}</td>
            <td>{f.row_number != null ? `Row ${f.row_number}` : "—"}</td>
            <td>{f.is_excluded ? "—" : (f.raw_score ?? <span className="text-muted">pending</span>)}</td>
            <td>{f.is_excluded ? "—" : (f.maximum_score ?? "—")}</td>
            <td>
              {f.is_not_applicable && <Badge bg="secondary" className="me-1">N/A</Badge>}
              {f.is_excluded && !f.is_not_applicable && <Badge bg="light" text="dark">Excluded</Badge>}
              {!f.is_excluded && !f.is_not_applicable && f.raw_score == null && <Badge bg="warning" text="dark">Awaiting score</Badge>}
            </td>
            <td><Badge bg={SOURCE_VARIANT[f.scoring_source] || "light"} text={f.scoring_source === "SYSTEM" ? "dark" : undefined}>{f.scoring_source}</Badge></td>
            <td className="small text-muted">{f.reviewer_remarks || "—"}</td>
          </tr>
        ))}
      </tbody>
    </Table>
  );
}
